var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramGalleryIcon({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: 22,
    viewBox: "0 0 48 48",
    width: 22,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 29.7V11c0-2.9-2.3-5.2-5.2-5.2H11c-2.9 0-5.2 2.3-5.2 5.2v18.7c0 2.9 2.3 5.2 5.2 5.2h18.7c2.8-.1 5.1-2.4 5.1-5.2zM39.2 15v16.1c0 4.5-3.7 8.2-8.2 8.2H14.9c-.6 0-.9.7-.5 1.1 1 1.1 2.4 1.8 4.1 1.8h13.4c5.7 0 10.3-4.6 10.3-10.3V18.5c0-1.6-.7-3.1-1.8-4.1-.5-.4-1.2 0-1.2.6z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiBoZWlnaHQ9IjIyIiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSIyMiI+PHBhdGggZD0iTTM0LjggMjkuN1YxMWMwLTIuOS0yLjMtNS4yLTUuMi01LjJIMTFjLTIuOSAwLTUuMiAyLjMtNS4yIDUuMnYxOC43YzAgMi45IDIuMyA1LjIgNS4yIDUuMmgxOC43YzIuOC0uMSA1LjEtMi40IDUuMS01LjJ6TTM5LjIgMTV2MTYuMWMwIDQuNS0zLjcgOC4yLTguMiA4LjJIMTQuOWMtLjYgMC0uOS43LS41IDEuMSAxIDEuMSAyLjQgMS44IDQuMSAxLjhoMTMuNGM1LjcgMCAxMC4zLTQuNiAxMC4zLTEwLjNWMTguNWMwLTEuNi0uNy0zLjEtMS44LTQuMS0uNS0uNC0xLjIgMC0xLjIuNnoiPjwvcGF0aD48L3N2Zz4K";
export { SvgInstagramGalleryIcon as ReactComponent };